import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

// The deal card — not nested under the queue (`deals_`): a full page with its
// own «Aelo › Deals › <deal>» crumbs. Access is the `deals` screen, as for the
// queue (the path prefix `/deals/<id>` resolves to it).
export const Route = createFileRoute('/deals_/$stateId')({
  component: lazyRouteComponent(() => import('./-deal-card.lazy'), 'default'),
});
